<div class="row" *ngIf="modelList.length > 0;else noDocument">
  <div [ngClass]="{'w-100': modelList.length == 1, 'col-md-6 col-sm-12':modelList.length > 1}" class="p-2" *ngFor="let header of modelList;">
    <div class="card rapporti-card p-0" style="min-height: 550px;">
      <div class="header-zona">
        <span class="titolo-card-doc">Monografie</span>
      </div>
      <div class="card-body rapporti-doc" style="min-height: 50px;">
        <div class="col-xxxl-12 col-md-12" *ngFor="let header of modelList;">
          <!-- <p class="titoloprincipale"><b>{{header.idCategoria | tipoCategorieDoc}}</b></p> -->
          <ul>
            <li *ngFor="let element of header.elements;">
              <a href="{{ websiteUrl }}{{ element.url }}"
              onclick="window.open(this.href + '#&navpanes=0&scrollbar=0&view=FitH', 'Monografie','left=20,top=20,width=800,height=700,resizable=1'); return false;"
              class="colored">{{element.descrizione}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <iframe id="monografie" name="monografie" src="docs/CDmonografie/Home.htm" scrolling="auto" frameborder="1" height="600px" width="100%" style="border: none;" >
      </iframe> -->

      <ng-template #noDocument>
        <div class="row">
            <div class="p-2 w-100">
              <div class="card rapporti-card p-0" style="min-height: 550px;">
                <div class="header-zona">
                  <span class="titolo-card-doc">Monografie</span>
                </div>
                <div class="card-body rapporti-doc" style="min-height: 50px;">
                  <div class="col-xxxl-12 col-md-12" >Nessun contenuto recuperato per questa sezione
                  </div>
                </div>
              </div>
            </div>
          </div>
            
        </ng-template>